import { Commit, ActionTree } from 'vuex';
import { State } from '@/store/modules/synthetics/secretManager/secretManager.store';
import graphQl from '@/services/graphQl';
import { AxiosResponse } from 'axios';

const actions: ActionTree<State, any> = {
  async GET_ALL_SECRETS(
    context: { commit: Commit; rootState: any },
    params: any
  ) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getAllSecretsList')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.secretsList;
        } else return [];
      });
  },
  async SAVE_SECRET_TOKEN(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('saveSecretToken')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.pulseInfoResponse;
        } else return [];
      });
  },
  async GET_TOKEN_LINKED_SECRET(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('getTokensLinkedToSecretList')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.tokensList;
        } else return [];
      });
  },
  async DELETE_SECRET(context: { commit: Commit }, params: any) {
    if (!params) {
      return new Promise<void>(resolve => resolve());
    }
    return graphQl
      .query('deleteSecret')
      .params(params)
      .then((res: AxiosResponse) => {
        if (res.data) {
          return res.data.data.deleteSecretResponse;
        } else return [];
      });
  },
};

export default actions;
